<template>
    <div>
        <CustomerMail
            type="dropdown-item"
            :customer="mailModalCustomer"
            @close="mailModalCustomer = null"
            @mailSent="mailModalCustomer = null"
        />

        <CustomersDeleteModal
            :customer="deleteModalCustomer"
            @close="deleteModalCustomer = null"
            @deleted="onCustomerDeleted"
        />

        <div class="row">
            <div class="column small-7">
                <PageTitle title="Klanten" :total="total" :loading="loading" />
            </div>
            <div class="column small-5 text-right">
                <b-tooltip :label="hideSensitiveData ? 'Toon gevoelige data' : 'Verberg gevoelige data'" position="is-left">
                    <b-button :type="hideSensitiveData ? 'is-success' : 'is-danger'" :icon-right="hideSensitiveData ? 'eye' : 'eye-slash'" @click="$store.dispatch('toggleSensitiveData')"></b-button>
                </b-tooltip>
                <b-button type="is-dark" tag="router-link" to="/panel/klanten/nieuw" v-if="!user.deurwaarder">Nieuwe klant</b-button>
            </div>
        </div>

        <div class="row" v-if="!user.deurwaarder">
            <div class="column">
                <b-field label="Zoek een klant">
                    <b-autocomplete
                        :data="customersFound"
                        field="number"
                        placeholder="Zoek op naam, straatnaam, plaats, e-mailadres, telefoonnummer, bedrijfsnaam of bankrekening"
                        :loading="isFetching"
                        @typing="findCustomer"
                        @select="option => selectedCustomer = option">
                        <template v-slot="props">
                            <span v-if="user && user.role == 'pit' && dataBelongsTo == 'all'">{{ organisations[props.option.organisation] ? organisations[props.option.organisation].name : '' }}&nbsp;-&nbsp;</span><strong>{{ props.option.firstname }}&nbsp;{{ props.option.lastname }}</strong> - {{ props.option.email }}
                            <span v-if="props.option.companyname"> ({{ props.option.companyname }}) </span> - {{ props.option.city }}
                        </template>
                    </b-autocomplete>
                </b-field>
            </div>
        </div>
        <div class="row" v-else>
            <div class="column">
                <b-notification type="is-warning" role="alert">
                    Voor jouw rol zijn alleen klanten met geëscaleerde facturen zichtbaar.
                </b-notification>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <b-table
                    :data="records"
                    :striped="true"
                    :loading="loading"
                    :mobile-cards="true"

                    backend-pagination
                    :total="total"
                    :per-page="perPage"
                    @page-change="onPageChange"
                    backend-sorting
                    :default-sort-direction="sortOrder"
                    :default-sort="[sortField, sortOrder]"
                    @sort="onSort"

                    :paginated="paginated"
                    :sort-icon="'chevron-up'"
                >
                    <template>
                        <b-table-column v-slot="props" field="organisation" label="Org." width="50" :visible="user && user.role == 'pit' && $store.state.dataBelongsTo === 'all'" class="admin">
                            <b-button type="is-primary" outlined tag="router-link" size="is-small" :to="{ name: 'OrganisationsRecord', params: {id: props.row.organisation} }">
                                {{ _.has(organisations, props.row.organisation) ? organisations[props.row.organisation].short_name : '-' }}
                            </b-button>
                        </b-table-column>

                        <b-table-column v-slot="props" field="lastname" label="Naam" width="150" sortable>
                            <!-- <span v-if="hideSensitiveData">********</span>
                            <span v-else>
                                {{ props.row.firstname }}&nbsp;{{ props.row.lastname }}
                                <span v-if="!_.isNull(props.row.companyname) && props.row.type == 'business'" :icon="!_.isNull(props.row.companyname) && props.row.type == 'business' ? 'building' : 'people'">
                                    <br><strong>{{ props.row.companyname }}</strong>
                                </span>
                            </span> -->
                            <!-- <b-button tag="router-link" type="is-text" size="is-small" class="text-left" :to="{ name: 'CustomersRecord', params: {id: props.row.id} }">
                                <span v-if="hideSensitiveData">********</span>
                                <span v-else style="line-height: 1">
                                    <span style="width: 150px;display: inline-block;white-space: nowrap;overflow: hidden !important;text-overflow: ellipsis;">{{ props.row.firstname }}&nbsp;{{ props.row.lastname }}</span>
                                    <br>
                                    <span v-if="!_.isNull(props.row.companyname) && (props.row.type == 'business' || props.row.type == 'foundation')" :icon="!_.isNull(props.row.companyname) && props.row.type == 'business' ? 'building' : 'people'">
                                        <span style="width: 150px;display: inline-block;white-space: nowrap;overflow: hidden !important;text-overflow: ellipsis;"><strong>{{ hideSensitiveData ? '********' : props.row.companyname }}</strong></span>
                                    </span>
                                </span>
                            </b-button> -->

                            <router-link :to="{ name: 'CustomersRecord', params: {id: props.row.id} }">
                                <strong>{{ props.row.firstname }}&nbsp;{{ props.row.lastname }}</strong>
                                <span v-if="!_.isNull(props.row.companyname) && (props.row.type == 'business' || props.row.type == 'foundation')" :icon="!_.isNull(props.row.companyname) && props.row.type == 'business' ? 'building' : 'people'">
                                    <br v-if="props.row.type == 'business' || props.row.type == 'foundation'">
                                    <strong style="font-size: 0.8rem;">{{ hideSensitiveData ? '********' : props.row.companyname }}</strong>
                                </span>
                            </router-link>
                        </b-table-column>

                        <b-table-column v-slot="props" field="boxes" label="Box nr." width="160" v-if="user.organisation_type && user.organisation_type == 'box'">
                            <span v-for="(box, index) in _.uniqBy(props.row.boxes, (box) => box.id )" :key="box.id">
                                <b-button tag="router-link" :to="{ name: 'BoxesRecord', params: {id: box.id} }" type="is-light" size="is-small" v-if="index < 2">
                                    {{ box.number|truncate(10, '..') }}
                                </b-button>
                                <b-tooltip v-if="index === 2" :label="props.row.boxes.slice(2).map(box => box.number).join(', ')">
                                    <b-button type="is-light" size="is-small">+{{ props.row.boxes.length - 2 }}</b-button>
                                </b-tooltip>
                            </span>
                        </b-table-column>

                        <b-table-column v-slot="props" field="access" label="Toegang" width="80" sortable :visible="(user.role == 'pit' || user.organisation_connect) && !user.deurwaarder">
                            <b-tooltip :label="!_.isNull(props.row.access.date_to) && moment(props.row.access.date_to).format('YMMDD') > moment(new Date()).format('YMMDD') || _.isNull(props.row.access.date_to) ? 'Actief' : 'Verlopen'" v-if="props.row.access">
                                <router-link :to="{ name: 'ConnectRecord', params: {id: props.row.access.id} }">
                                    <b-button :type="!_.isNull(props.row.access.date_to) && moment(props.row.access.date_to).format('YMMDD') > moment(new Date()).format('YMMDD') || _.isNull(props.row.access.date_to) ? 'is-success' : 'is-danger'" icon-right="key" size="is-small" />

                                    <!-- <div v-if="!_.isNull(props.row.access.date_to) && moment(props.row.access.date_to).format('YMMDD') > moment(new Date()).format('YMMDD')  ">
                                        {{ moment(props.row.access.date_to).format('YMMDD') }}<br>
                                        {{ moment(new Date()).format('YMMDD') }}
                                    </div> -->
                                </router-link>
                            </b-tooltip>

                            <b-tooltip label="Toegang aanmaken" v-else>
                                <router-link :to="{ name: 'ConnectRecord', params: {id: 'nieuw'}, query: { customer: props.row.id } }">
                                    <b-button type="is-light" size="is-small" icon-right="key" />
                                </router-link>
                            </b-tooltip>
                        </b-table-column>

                        <b-table-column v-slot="props" field="type" label="Type" sortable>
                            <span v-if="hideSensitiveData">********</span>
                            <span v-else>{{ props.row.type == 'normal' ? 'Particulier' : props.row.type == 'business' ? 'Zakelijk' : props.row.type == 'foundation' ? 'Stichting' : props.row.type }}</span>
                        </b-table-column>

                        <b-table-column v-slot="props" field="email" label="E-mailadres" sortable>
                            <span style="width: 150px;display: inline-block;white-space: nowrap;overflow: hidden !important;text-overflow: ellipsis;">
                                {{ hideSensitiveData ? '********' : props.row.email }}
                            </span>
                        </b-table-column>

                        <b-table-column v-slot="props" field="city" label="Plaats" sortable>
                            {{ hideSensitiveData ? '********' : props.row.city }}
                        </b-table-column>

                        <b-table-column v-slot="props" field="updated_at" label="Laatst gewijzigd" sortable>
                            <span>{{ props.row.updated_at|humanDate }}</span>
                        </b-table-column>

                        <b-table-column v-slot="props" field="actions" width="100" numeric>
                            <div class="invoice-options-dropdown">
                                <b-button tag="router-link" type="is-dark" size="is-small" :to="'/panel/klanten/'+props.row.id">Bekijken</b-button>
                                <b-dropdown :triggers="['click', 'hover']" aria-role="list" position="is-bottom-left" class="is-inline-block">
                                    <template #trigger>
                                        <b-button
                                            type="is-dark"
                                            size="is-small"
                                            class="is-inline-flex"
                                            icon-right="chevron-down" />
                                    </template>

                                    <b-dropdown-item @click="mailModalCustomer = props.row" :disabled="!props.row">
                                        Klant mailen
                                    </b-dropdown-item>

                                    <router-link class="dropdown-item" :to="{ name: 'CreateInvoiceRecord', query: { customer: props.row.id } }">
                                        Factuur maken
                                    </router-link>

                                    <b-dropdown-item @click="deleteModalCustomer = props.row" class="has-text-danger">
                                        Verwijderen
                                    </b-dropdown-item>
                                </b-dropdown>
                            </div>
                        </b-table-column>
                    </template>

                    <template #empty>
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p class="margin0" v-if="loading === false">Geen klanten gevonden.</p>
                                <p class="margin0" v-else>Laden...</p>
                            </div>
                        </section>
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>

<script>
import filtersMixin from '@/mixins/filterMixins'
import paramsMixin from '@/mixins/paramsMixin'
import CustomerMail from './components/CustomerMail.vue'
import CustomersDeleteModal from './CustomersDeleteModal.vue'

export default {
    name: 'CustomersOverview',

    mixins: [filtersMixin, paramsMixin],

    components: {
        CustomerMail,
        CustomersDeleteModal
    },

    data(){
        return {
            loading: true,

            records: [],
            total: null,
            sortField: 'updated_at',
            sortOrder: 'desc',
            defaultSortOrder: 'desc',
            page: 1,
            perPage: 35,

            searchParams: typeof(this.$store.state.searchQueries['CustomersOverview']) != 'undefined' ? this.$store.state.searchQueries['CustomersOverview'] : null,

            customersFound: [],
            selectedCustomer: null,
            isFetching: false,
            mailModalCustomer: null,
            deleteModalCustomer: null
        }
    },

    computed: {
        paginated(){
            return this.records ? this.records.length < this.total : false
        },
        user() {
            return this.$store.state.user
        },
        organisations() {
            return this.$store.state.organisations ? this.$store.state.organisations : null
        },
        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        }
    },

    created(){
        this.getSearchParams().then(() => {
            this.loadAsyncData()
        })
    },

    methods: {
        loadAsyncData(){
            // Set filter params & admin params
            const params = this.setParams(this.searchParams, 'CustomersOverview')

            this.loading = true

            axios.get(`/api/customers?${params}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.records = []

                this.total = response.data.total
                this.page = response.data.current_page
                this.records = response.data.data

                this.$store.dispatch('setSearchQuery', {type: 'CustomersOverview', query: params})
            }).catch((error) => {
                console.error('[❌] Error while fetching the customers:', error)
                this.data = []
                this.total = null
            }).then(() => {
                this.loading = false
                this.searchParams = null
            })
        },

        findCustomer: _.debounce(function (name) {
            if (!name.length) {
                this.data = []
                return
            }
            this.isFetching = true

            let searchParm = `search=${name}`
            if (this.user?.role === 'pit') {
                searchParm += `&organisation=${this.dataBelongsTo}`
            }

            axios.get(`/api/customer/find?${searchParm}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.customersFound = response.data.data
            }).catch((error) => {
                console.error('[❌] Error while searching customer:', error)
            }).then(() => {
                this.isFetching = false
            })
        }, 250),

        onPageChange(page) {
            this.page = page
            this.loadAsyncData()
        },

        onSort(field, order) {
            this.sortField = field
            this.sortOrder = order
            this.loadAsyncData()
        },

        onCustomerDeleted(customerId) {
            this.records = this.records.filter(r => r.id !== customerId)
            this.total = this.total ? this.total - 1 : 0
        }
    },

    watch: {
        // Go to selected box
        selectedCustomer(newVal){
            if(!_.isNull(newVal)){
                this.$router.push({'name': 'CustomersRecord', params: {id: newVal.id}})
            }
        }
    }
}
</script>
